
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen pt-32 pb-20 px-20 bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="relative max-w-[1440px] mx-auto">
        <div className="grid grid-cols-12 gap-8 items-start">
          <div className="col-span-7 pt-16">
            <h1 className="text-7xl font-bold leading-tight text-gray-900 mb-12" style={{ fontFamily: 'Playfair Display, serif' }}>
              Crafting Premium<br />
              iOS<br />
              Experiences
            </h1>
            
            <div className="space-y-4 mb-8">
              <p className="text-lg text-gray-600 font-light leading-relaxed">
                Expert team specializing in VPN and Cleaner applications
              </p>
              <p className="text-lg text-gray-600 font-light leading-relaxed">
                Enhancing security and performance for mobile users worldwide
              </p>
            </div>
            
            <div className="w-32 h-1 bg-orange-500"></div>
          </div>
          
          <div className="col-span-3 flex justify-center">
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/53d97702de456b1fa51a06e11daad13b.jpg" 
                alt="VPN App Interface"
                className="w-full h-auto rounded-3xl shadow-2xl object-cover"
              />
            </div>
          </div>
          
          <div className="col-span-2 space-y-6">
            <div className="relative group cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=iPhone%20VPN%20application%20connection%20screen%20interface%20showing%20secure%20connection%20status%20with%20blue%20accent%20colors%20modern%20iOS%20design%20clean%20white%20background%20minimalist%20UI%20elements%20professional%20mobile%20app%20screenshot&width=280&height=280&seq=hero-vpn-square&orientation=squarish" 
                alt="VPN Connection Interface"
                className="w-full h-auto rounded-2xl shadow-lg object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-lg">
                <span className="text-xs font-medium text-gray-900">VPN App</span>
              </div>
            </div>
            
            <div className="relative group cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=iPhone%20Cleaner%20application%20dashboard%20interface%20showing%20storage%20optimization%20with%20orange%20accent%20colors%20modern%20iOS%20design%20clean%20white%20background%20minimalist%20UI%20with%20charts%20and%20statistics%20professional%20mobile%20app%20screenshot&width=280&height=280&seq=hero-cleaner-square&orientation=squarish" 
                alt="Cleaner App Dashboard"
                className="w-full h-auto rounded-2xl shadow-lg object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-lg">
                <span className="text-xs font-medium text-gray-900">Cleaner App</span>
              </div>
            </div>
            
            <div className="relative group cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=iPhone%20analytics%20application%20screen%20showing%20performance%20metrics%20and%20data%20visualization%20with%20green%20accent%20colors%20modern%20iOS%20design%20clean%20white%20background%20minimalist%20UI%20professional%20mobile%20app%20screenshot&width=280&height=280&seq=hero-analytics-square&orientation=squarish" 
                alt="App Analytics Screen"
                className="w-full h-auto rounded-2xl shadow-lg object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-lg">
                <span className="text-xs font-medium text-gray-900">Analytics</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
